import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
interface Testimonial {
  code: string;
  name: string;
  service: string;
  rating: number;
  quote: string;
  date: string;
}
const testimonials: Testimonial[] = [{
  code: 'REV-01',
  name: 'Олександр Ковальчук',
  service: 'Ремонт двигуна · BMW E60',
  rating: 5,
  quote: 'Жодних зайвих робіт і прихованих платежів. Чесно показали проблему, узгодили кошторис і виконали все точно у строк. Нарешті майстерня, де говорять з тобою як з людиною.',
  date: '12.03.2025'
}, {
  code: 'REV-02',
  name: 'Марія Левченко',
  service: 'Діагностика та підвіска · VW Passat',
  rating: 5,
  quote: 'Приїхала з підозрою на серйозну поломку. Інші СТО пропонували міняти пів машини, а тут спокійно продіагностували й полагодили те, що дійсно було потрібно. Ціна — справедлива.',
  date: '28.02.2025'
}, {
  code: 'REV-03',
  name: 'Дмитро Іщенко',
  service: 'Ремонт турбіни · Audi A4',
  rating: 5,
  quote: 'Військовий підхід відчутний у всьому — від запису до видачі авто. Звітували по кожному етапу, дотрималися строків до години. Професіоналізм найвищого рівня.',
  date: '15.02.2025'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-zinc-950 text-white py-24 px-6 md:px-12 lg:px-20 border-t border-white/5" data-id="element-228">
      <div className="max-w-7xl mx-auto" data-id="element-229">
        {/* Header */}
        <div className="mb-16" data-id="element-230">
          <div className="flex items-center gap-3 mb-4" data-id="element-231">
            <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-232" />
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-233">
              Відгуки · Польові звіти
            </span>
          </div>
          <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest mb-3" data-id="element-234">
            Слово клієнтів
          </h2>
          <p className="text-zinc-500 text-sm max-w-2xl" data-id="element-235">
            Реальні відгуки людей, які довірили нам свої автомобілі. Чесно, без
            прикрас.
          </p>
        </div>

        {/* Divider */}
        <div className="flex items-center justify-between mb-8 pb-4 border-b border-white/10" data-id="element-236">
          <div className="flex items-center gap-4" data-id="element-237">
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest" data-id="element-238">
              UNIT 02
            </span>
            <span className="font-['Oswald'] text-2xl font-bold text-white uppercase tracking-widest" data-id="element-239">
              Перевірено в бою
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-240">
            <div className="flex items-center gap-0.5" data-id="element-241">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#6B7A4A] text-[#6B7A4A]" data-id="element-242" />)}
            </div>
            <span className="font-['JetBrains_Mono'] text-xs text-zinc-600 tracking-wider" data-id="element-243">
              5.0 / 248 ВІДГУКІВ
            </span>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-244">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.code} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="group relative bg-neutral-900/50 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 p-7 flex flex-col" data-id="element-245">
              {/* Corner brackets */}
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-246" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-247" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-248" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-249" />

              {/* Header row: code + rating */}
              <div className="flex items-center justify-between mb-5" data-id="element-250">
                <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase" data-id="element-251">
                  {testimonial.code}
                </span>
                <div className="flex items-center gap-0.5" data-id="element-252">
                  {Array.from({
                length: testimonial.rating
              }).map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#6B7A4A] text-[#6B7A4A]" data-id="element-253" />)}
                </div>
              </div>

              {/* Quote icon */}
              <Quote className="w-7 h-7 text-[#6B7A4A]/40 mb-4" strokeWidth={1.5} data-id="element-254" />

              {/* Quote text */}
              <p className="text-zinc-300 text-base leading-relaxed font-['Inter'] mb-8 flex-1" data-id="element-255">
                {testimonial.quote}
              </p>

              {/* Footer: name, service, date */}
              <div className="pt-5 border-t border-white/10" data-id="element-256">
                <div className="flex items-start gap-3" data-id="element-257">
                  {/* Initials avatar */}
                  <div className="w-10 h-10 shrink-0 bg-[#6B7A4A]/10 border border-[#6B7A4A]/30 flex items-center justify-center" data-id="element-258">
                    <span className="font-['Oswald'] text-sm font-bold text-[#6B7A4A] uppercase tracking-wider" data-id="element-259">
                      {testimonial.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-260">
                    <div className="font-['Oswald'] text-base uppercase tracking-wide text-white truncate" data-id="element-261">
                      {testimonial.name}
                    </div>
                    <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1 truncate" data-id="element-262">
                      {testimonial.service}
                    </div>
                  </div>
                  <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-600 tracking-wider shrink-0" data-id="element-263">
                    {testimonial.date}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Trust strip */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-12 pt-8 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-264">
          {[{
          value: '100%',
          label: 'Чесна оцінка'
        }, {
          value: '0',
          label: 'Нав\u2019язаних робіт'
        }, {
          value: '24Г',
          label: 'Зворотний зв\u2019язок'
        }, {
          value: '5.0',
          label: 'Середній рейтинг'
        }].map(stat => <div key={stat.label} className="flex flex-col" data-id="element-265">
              <div className="font-['Oswald'] text-3xl md:text-4xl font-bold text-[#6B7A4A]" data-id="element-266">
                {stat.value}
              </div>
              <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-2" data-id="element-267">
                {stat.label}
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}